import { createSlice } from 'utils/@reduxjs/toolkit';
import { MountingPartState } from './types';
import { reducers } from './reducers';

export const initialState: MountingPartState = {
  isLoading: false,
  data: null,
  error: null,
};

const slice = createSlice({
  name: 'mountingPart',
  initialState,
  reducers,
});

export const { actions: mountingPartActions } = slice;
export const { reducer: mountingPartReducer } = slice;
